import React, { useState } from "react"
import emailjs from "emailjs-com"
import { Container } from "../components/Sections"

function ContactPageTemplate({ heading, subheading, contactform, office }) {
  const [formData, setFormData] = useState({
    firstName: "",
    to_name: "Pérola Branca",
    email: "",
    phone: "",
    message: "",
  })

  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)

  const validateForm = () => {
    const newErrors = {}
    if (!formData.firstName.trim()) newErrors.firstName = "Nome é obrigatório."
    if (!formData.email.trim()) {
      newErrors.email = "Email é obrigatório."
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Formato de email inválido."
    }
    if (!formData.message.trim()) newErrors.message = "Mensagem é obrigatória."
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = e => {
    console.log("submitting form")
    e.preventDefault()

    if (validateForm()) {
      emailjs
        .send(
          "service_u7l1e6k",
          "template_i7o33v9",
          {
            firstName: formData.firstName,
            email: formData.email,
            phone: formData.phone,
            to_name: "Pérola Branca",
            message: formData.message,
          },
          "36ObUMjsgIrvkx46I"
        )
        .then(response => {
          console.log("SUCCESS!", response.status, response.text)
          setSubmitted(true)
        })
        .catch(err => {
          console.log("FAILED...", err)
        })
    }
  }

  return (
    <div className="relative">
      <img
        src="/img/7.png"
        alt="contact background"
        className="absolute inset-0 w-full h-full"
      />
      <Container id="contactos">
        <div className="px-4 md:px-8">
          <h2 className="mb-4 text-2xl text-center uppercase text-primary-dark md:text-4xl font-rasputin tracking-extra">
            FORMULÁRIO DE CONTACTO
          </h2>
          <p className="text-center text-black">
            Gostaria de saber mais em relação aos nossos serviços?
            <br />
            Preencha o formulário de contacto e responderemos o mais brevemente
            possível.{" "}
          </p>
        </div>
        {submitted ? (
          <p className="text-center text-green-600">
            Formulário enviado com sucesso! Entraremos em contato em breve.
          </p>
        ) : (
          <div image="" className="relative z-50 mt-8">
            <form onSubmit={handleSubmit} method="POST">
              <div className="grid grid-cols-2 col-span-2 md:col-span-1">
                <div className="grid grid-cols-12 col-span-2 gap-6 md:col-span-1">
                  <div className="col-span-12">
                    <label
                      htmlFor="first-name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Nome
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      id="first-name"
                      autoComplete="given-name"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-primary-dark focus:border-primary-dark sm:text-sm"
                    />
                    {errors.firstName && (
                      <p className="text-sm text-red-500">{errors.firstName}</p>
                    )}
                  </div>

                  <div className="col-span-12">
                    <label
                      htmlFor="email-address"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Email
                    </label>
                    <input
                      type="text"
                      name="email"
                      id="email-address"
                      autoComplete="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-primary-dark focus:border-primary-dark sm:text-sm"
                    />
                    {errors.email && (
                      <p className="text-sm text-red-500">{errors.email}</p>
                    )}
                  </div>

                  <div className="col-span-12">
                    <label
                      htmlFor="phone"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Telemóvel
                    </label>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      autoComplete="tel"
                      value={formData.phone}
                      onChange={handleChange}
                      className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-primary-dark focus:border-primary-dark sm:text-sm"
                    />
                  </div>

                  <div className="col-span-12">
                    <label
                      htmlFor="message"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Mensagem
                    </label>
                    <span className="text-sm text-gray-500">
                      Max. 700 caracteres
                    </span>
                    <textarea
                      id="message"
                      name="message"
                      rows={7}
                      value={formData.message}
                      onChange={handleChange}
                      className="block w-full mt-1 border border-gray-300 rounded-md shadow-sm focus:ring-primary-dark focus:border-primary-dark sm:text-sm"
                    />
                    {errors.message && (
                      <p className="text-sm text-red-500">{errors.message}</p>
                    )}
                  </div>

                  <div className="py-3 mt-2 text-right">
                    <button
                      type="submit"
                      className="inline-flex justify-center py-2 px-12 min-w-[200px] border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-dark hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark"
                    >
                      Enviar
                    </button>
                  </div>
                </div>
                <div className="flex col-span-2 m-auto md:col-span-1">
                  <img src="/img/logo.png" alt="patricia bouças logo" />
                </div>
              </div>
            </form>
          </div>
        )}
      </Container>
    </div>
  )
}

export default ContactPageTemplate
